import AdminUsersPage from './AdminUsersPage';

export default function AdminTeachers() {
  return <AdminUsersPage userType="teacher" />;
}
